<template>
    <div id="generalCheckinForm" class="card mb-3">
        <div class="card-body">
            <h6 class="card-title font-weight-bold"><i class="fas fa-cog"></i> System</h6>
            <div class="form-group">
                <label>Maximum Capacity</label>
                <input v-model="maximumCapacity" type="number" class="form-control">
            </div>
            <div class="form-group">
                <label>Capacity Threshold (%)</label>
                <input v-model="capacityThreshold" type="number" min="0" max="100" class="form-control"
                    @input="validateCapacityThreshold()">
                <small class="form-text text-muted">Select a value between 0 and 100. Please note that the value is in
                    percentages. A value of 0 will turn off the capacity threshold.</small>
            </div>
            <div class="form-group">
                <label>Available Appointment Type(s)</label>
                <select v-model="appointmentType" class="form-control">
                    <option value="all">In-person and Virtual</option>
                    <option value="inperson">In-person</option>
                    <option value="virtual">Virtual</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'general-checkin-settings-form',
    props: {
        settings: {
            required: true
        }
    },
    data() {
        return {
            appointmentType: 'all',
            capacityThreshold: 0,
            maximumCapacity: 0
        }
    },
    methods: {
        getSettings() {
            return {
                appointmentType: this.appointmentType,
                capacityThreshold: this.capacityThreshold,
                maximumCapacity: this.maximumCapacity,
                type: 'general'
            }
        },
        setSettings() {
            let settings = this.settings.types || [];
            let system = {};

            if (settings.length > 0) {
                settings.forEach(setting => {
                    system = setting.type && setting.type == "general" ? setting : system;
                });
            }

            this.capacityThreshold = system.capacityThreshold ? system.capacityThreshold : this.capacityThreshold;
            this.appointmentType = system.appointmentType ? system.appointmentType : this.appointmentType;
            this.maximumCapacity = system.maximumCapacity ? system.maximumCapacity : this.maximumCapacity;
        },
        validateCapacityThreshold() {
            if (this.capacityThreshold < 0) {
                this.capacityThreshold = 0;
            }
            else if (this.capacityThreshold > 100) {
                this.capacityThreshold = 100;
            }
        }
    }
}
</script>